var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warm-range"},[_c('div',{staticClass:"second-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('el-switch',{attrs:{"active-text":"开启","inactive-text":"关闭"},on:{"change":_vm.handleCheck},model:{value:(_vm.localChecked),callback:function ($$v) {_vm.localChecked=$$v},expression:"localChecked"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }